import { Code, ConnectError } from '@connectrpc/connect';
/**
 * Whether a Workroom chat renders read-only (SAD-756).
 *
 *  - GetConversation succeeded → the server's verdict (`readOnly`).
 *  - NotFound → a chat the caller is just creating (no shanks row until the
 *    first send; shanks also answers NotFound for rows the caller cannot see,
 *    and rejects their send), so writable — unless zou's chat record already
 *    says the caller is not its owner.
 *  - Anything else (PermissionDenied, transport…) → never writable.
 */ export function workroomChatReadOnly(probe, knownNotOwner = false) {
    if (probe.ok) return probe.readOnly;
    const isNotFound = probe.error instanceof ConnectError && probe.error.code === Code.NotFound;
    return !isNotFound || knownNotOwner;
}
